// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeHeader_root__3Qc5p","biglogo":"HomeHeader_biglogo__24fRb","caps":"HomeHeader_caps__3v04r","buttons":"HomeHeader_buttons__1gvjX","button":"HomeHeader_button__3S2Vv"};